module.exports = __webpack_public_path__ + "static/media/Bip.f47b4ad4.mp3";